import { Skeleton } from '@app/components/various/Skeleton';

export const CheckboxSkeleton = () => <Skeleton type="rectangle" aspectRatio={1} className="w-[18px] rounded-small" />;
